import { render } from "./ShortlistedListView.vue?vue&type=template&id=57a18264&scoped=true"
import script from "./ShortlistedListView.vue?vue&type=script&lang=js"
export * from "./ShortlistedListView.vue?vue&type=script&lang=js"

import "./ShortlistedListView.vue?vue&type=style&index=0&id=57a18264&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a18264"]])

export default __exports__